import StringContainsComparatorFilterConverter from "./StringContainsComparatorFilterConverter.js";
import StringEndsWithComparatorFilterConverter from "./StringEndsWithComparatorFilterConverter.js";
import StringEqualsComparatorFilterConverter from "./StringEqualsComparatorFilterConverter.js";
import StringNotEqualsComparatorConverter from "./StringNotEqualsComparatorFilterConverter.js";
import StringStartsWithComparatorFilterConverter from "./StringStartsWithComparatorFilterConverter.js";
export default {
  install(molten) {
    molten.addPlugin('ImagineComparatorFilterConverter', StringEqualsComparatorFilterConverter);
    molten.addPlugin('ImagineComparatorFilterConverter', StringNotEqualsComparatorConverter);
    molten.addPlugin('ImagineComparatorFilterConverter', StringStartsWithComparatorFilterConverter);
    molten.addPlugin('ImagineComparatorFilterConverter', StringEndsWithComparatorFilterConverter);
    molten.addPlugin('ImagineComparatorFilterConverter', StringContainsComparatorFilterConverter);
  }
};